module.exports = __webpack_public_path__ + "static/media/glass.a591b1f7.svg";